import { Component, Input, Output, EventEmitter, Inject } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { FormGroup, FormControl } from '@angular/forms';
import { GLOBAL } from '../global';
import { NotificationServiceBus } from '../../notification/notification.service';

export interface DialogData {
  title?: string;
  popupMessage: string;
  okTitle: string;
  cancelTitle?: string;
}
@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.css']
})
export class PopupComponent {

  @Input() title = this.data && this.data.title || '';
  @Input() popupMessage = this.data && this.data.popupMessage || '';
  @Input() okTitle = this.data && this.data.okTitle || '';
  @Input() cancelTitle = this.data && this.data.cancelTitle || '';
  @Input() closeVal = false;
  @Input() needReasonComponent = false;
  @Output() cancelReason: EventEmitter<string> = new EventEmitter();
  public reasonOfCancel = '';

  constructor(public dialogRef: MdDialogRef<PopupComponent>, public notificationServiceBus: NotificationServiceBus, @Inject(MD_DIALOG_DATA) public data: DialogData) {}

  closeDialog(val, closePressed) {
    if ((this.reasonOfCancel === '' && this.needReasonComponent) && !closePressed) {
      this.notificationServiceBus.launchNotification(true, GLOBAL.MISSING_FIELDS_ERROR_MESSAGE);
      return;
    } else {
      this.dialogRef.close(val);
      this.reasonOfCancel = '';
    }
  }

  cancellationReasonHandler(reason: string) {
    this.reasonOfCancel = reason;
    this.cancelReason.emit(reason);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/popup/popup.component.ts